module.exports = __webpack_public_path__ + "img/89.41ac8ca5.jpg";